module.exports = __webpack_public_path__ + "img/card-contract-document-configuration.acf10fd1.svg";